import * as React from 'react'
import { FunctionComponent } from 'react'
import NoteOverview from './NoteOverview'
import { noteBaseUrl } from '../Notes'

const GlobalNoteOverview: FunctionComponent = () => <NoteOverview baseUrl={noteBaseUrl} notes={null} reset={null} />

export default GlobalNoteOverview
